import * as React from 'react';
import { Input } from '@app/src/components/Input';
import { Field } from '@app/src/components/Field';

export const RenderInput = ({
  label,
  type,
  disabled,
  maxLength,
  meta: { error, touched },
  placeholder: placeholder,
  input,
  ...rest
}) => {
  let isError = (error && touched && !disabled) ? error : '';
  return(
    <Field label={label} errorMessage={isError}>
      <Input
        type={type}
        disabled={disabled}
        maxLength={maxLength}
        placeholder={placeholder}
        {...input}
        {...rest}
        error={!!isError} />
    </Field>
  );
};
